<template>
    <div class="purchase-course">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="block">
                    <h3>
                        Course
                    </h3>

                    <div v-if="showDateSetSelector">
                        <p>
                            Please select a period to see pricing.
                        </p>

                        <select v-model="selectedDateSetIndex">
                            <option value="">Please select</option>
                            <option v-for="(dateset, i) in datesets" :value="i">
                                {{ dateset.name }}
                            </option>
                        </select>
                    </div>

                    <template v-if="selectedDateSetIndex !== ''">
                        <table class="table table-bordered table-light mt-3">
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Class date and time</th>
                                    <th>Class length</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(date, key) in datesets[selectedDateSetIndex].dates">
                                    <td>
                                        {{ date.class.name }}
                                    </td>
                                    <td>
                                        {{ date.classDateTimeFormatted }}
                                    </td>
                                    <td>
                                        {{ date.class.duration }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="row">
                            <div class="col-md-6">
                                <template v-if="datesets[selectedDateSetIndex].is_free">
                                    This course is free.
                                </template>
                                <template v-else>
                                    <strong>Members price:</strong>
                                    {{ datesets[selectedDateSetIndex].priceActiveFormatted }}
                                    <a href="javascript: void(0);" @click="openHelpModal" class="text-white">(What's this?)</a>
                                    <template v-if="datesets[selectedDateSetIndex].is_available_non_subs">
                                        <br>
                                        <strong>Non-members price:</strong>
                                        {{ datesets[selectedDateSetIndex].priceActiveNonSubsFormatted }}<br>
                                    </template>
                                </template>
                            </div>
                            <div class="col-md-6 text-right">
                                <template v-if="!isActiveSoldOut">
                                    <template v-if="!isAuth">
                                        <a :href="'/register?return=' + course.uri" class="btn btn-primary btn-block">Sign Up</a>
                                    </template>
                                    <template v-else>
                                        <template v-if="!datesets[selectedDateSetIndex].is_available_non_subs && !isSubscribed">
                                            <p class="mb-0">
                                                Sorry, but this course is only available to members.
                                                Please <a :href="'/subscribe?return=' + course.uri" class="text-white">become a member</a> to enrol.
                                            </p>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-primary btn-block" @click="enrolClick">Get started</button>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <p class="h2 mb-0">Sold out</p>
                                </template>
                            </div>
                        </div>

                        <p v-if="isActiveScarce && !isActiveSoldOut" class="text-right mb-0 mt-1">
                            Only {{ activeScarcityNum }} seats left.
                        </p>
                    </template>

                </div>
            </div>
        </div>

        <b-modal ref="helpModal" size="lg" :title="'What is a membership?'" :ok-only="true" ok-variant="link" ok-title="Close">
            <p>
                Sign up for a <a href="/">Virtuoso annual membership</a> for £79.99 to get discounted access to all our live courses, as
                well as full access to our library of <a href="/courses">video courses</a> and loads of partner benefits to help you with your music.
            </p>
        </b-modal>

        <b-modal ref="enrolModal" size="lg" :title="'Enrol on ' + course.name" :ok-only="true" ok-variant="link" ok-title="Close">
            <enrol-course-button-component
                :course="course"
                :dateset="datesets[selectedDateSetIndex]"
                :slug="course.slug"
                :seat="'active'"></enrol-course-button-component>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            course: {
                type: Object,
                required: true,
            },
            datesets: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                selectedDateSetIndex: "",
                isAuth: false,
                isSubscribed: false,
                showDateSetSelector: true,
                user: {},
            }
        },

        computed: {
            observerScarcityNum: function () {
                if(this.datesets[this.selectedDateSetIndex].remainingObserverSeats <= 20) {
                    return 5;
                } else {
                    return this.datesets[this.selectedDateSetIndex].remainingObserverSeats;
                }
            },
            activeScarcityNum: function () {
                if(this.datesets[this.selectedDateSetIndex].remainingActiveSeats <= 20) {
                    return 3;
                } else {
                    return this.datesets[this.selectedDateSetIndex].remainingActiveSeats;
                }
            },
            isObserverScarce: function () {
                if(this.datesets[this.selectedDateSetIndex].remainingObserverSeats <= 50 && this.datesets[this.selectedDateSetIndex].remainingObserverSeats >= 0) {
                    return true;
                }
                return false;
            },
            isActiveScarce: function () {
                if(this.datesets[this.selectedDateSetIndex].remainingActiveSeats <= 20 && this.datesets[this.selectedDateSetIndex].remainingActiveSeats >= 0) {
                    return true;
                }
                return false;
            },
            isObserverSoldOut: function() {
                return this.course.no_observer_seats <= this.datesets[this.selectedDateSetIndex].no_enrolments_observer;
            },
            isActiveSoldOut: function() {
                return this.course.no_active_seats <= this.datesets[this.selectedDateSetIndex].no_enrolments_active;
            }
        },

        mounted() {
            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                }
                this.isSubscribed = window.virtuoso.is_subscribed;
            }

            if(this.datesets.length == 1) {
                this.selectedDateSetIndex = 0;
                this.showDateSetSelector = false;
            }
        },

        methods: {
            // Clicked to apply for a seat
            enrolClick() {
                this.$refs['enrolModal'].show('enrolModal');
            },

            // Clicked to apply for a seat
            openHelpModal() {
                this.$refs['helpModal'].show('helpModal');
            },
        }
    }
</script>
